import React, {useState, Suspense} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UI from "components/UI";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import UIUtils from "utils/UIUtils";
import TbSysPop from "../../../../domain/main/sys/pop/TbSysPop";
import mainPopupStore from "../../../../common/popup/store/MainPopupStore";
import UIUtil from "utils/UIUtils";


function ContentsContainer() {
	const modaladm5322 = useToggleState({});
	const history = useHistory();
    const location = useLocation();
    const [boardDetail, setBoardDetail] = useState<any>([]);
    const receivedData = (location.state as any)?.data;
    const notiNo = receivedData?.NOTI_NO;

    // 파일
    const [fileId,setFileId] = useState('관리자');
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [loadFinish,setLoadFinish] = useState(false);

    //파일정보 선언
    const [notiFileValue] = useState(new TbComFile());
    const [thumbFileValue] = useState(new TbComFile());

	const [thumbFile, setThumbFile] = useState(new TbComFileMapngDetail());
	const [imgSrc, setImgSrc] = useState('');
	const [thumDwldId, setThumbDwldId] = useState('');

    //초기 데이터 설정
    let data = {};
    let param = {};

	// 상세 조회
    async function getRead() {

        const response:any = await CommonUtil.execute({
            url: "adm_5110.jct",
            data: {NOTI_NO: notiNo}
        }).then((response: any) => {
            const result = response;
            setBoardDetail(response);

            notiFileValue.setTbComFileMapngDetailList([]);
            thumbFileValue.setTbComFileMapngDetailList([]);

            let fileList = result.FILE_INFO;
            if(fileList.length > 0){
                for(let i=0; i<fileList.length; i++){

					if(fileList[i].FILE_GB == 'FILE'){
						let fileInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(fileInfo.DWLD_ID);
						fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
						fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
						fileDetail.setStrePath(fileInfo.STRE_PATH);
						fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
						fileDetail.setFileSize(fileInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(fileInfo.REGIST_DT);
						notiFileValue.putTbComFileMapngDetailList(fileDetail);
					} else {
						let thumbInfo = fileList[i];

						//파일등록 정보
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(thumbInfo.DWLD_ID);
						fileDetail.setFileDetailId(thumbInfo.FILE_DETAIL_ID);
						fileDetail.setFilePolicy(thumbInfo.FILE_POLICY);
						fileDetail.setFileRpstr(thumbInfo.FILE_RPSTR);
						fileDetail.setStrePath(thumbInfo.STRE_PATH);
						fileDetail.setStreFileNm(thumbInfo.STRE_FILE_NM);
						fileDetail.setOrginlFileNm(thumbInfo.ORGINL_FILE_NM);
						fileDetail.setFileExtsn(thumbInfo.FILE_EXTSN);
						fileDetail.setFileSize(thumbInfo.FILE_SIZE);
						fileDetail.setRegistPsnNm(thumbInfo.REGIST_PSN_NM);
						fileDetail.setRegistDt(thumbInfo.REGIST_DT);
						thumbFileValue.putTbComFileMapngDetailList(fileDetail);
						getBase64(fileDetail);	// 썸네일 이미지 출력

					}

				}

            }
            setLoadFinish(true);



        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });
    }


    // 목록으로 이동
    async function onClickList(event) {
        //event.preventDefault();
        //let dataToSend = {};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5320',
        //  state: { data: receivedData }
        });
    };


    // 수정
    async function onClickEdit(event) {
        event.preventDefault();
        let dataToSend = {NOTI_NO : notiNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5324',
          state: { data: dataToSend }
        });
    };

    // 삭제
    async function onClickDelete(event) {
        event.preventDefault();

        if(window.confirm("삭제하시겠습니까?")) {
            param = {"NOTI_NO" : notiNo}
            const response:any = await CommonUtil.execute({
                url:"adm_5110_d001",
                data: param
            });
            UIUtils.alert("삭제되었습니다.").then();

            // 삭제 후 목록으로 이동
            history.push({
              pathname: './adm5320',
            });
        }

    };

	// 썸네일 이미지
	async function getBase64(tbComFileMapngDetail: TbComFileMapngDetail){

		const response:any = await CommonUtil.execute({
			url:'com_fileDownload',
			data: { DWLD_ID: tbComFileMapngDetail.getDwldId() }
		})

		const mineType = tbComFileMapngDetail.mimeType;
		const fileContent = `data:${mineType};base64,${response.FILE_LIST[0].FILE_NM}`

		setImgSrc(fileContent);
	}

    React.useEffect(() => {

        getRead();

    }, []);//effect


	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">게시판관리</Link></li>
					<li><Link to="#">우수사례관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">우수사례 상세</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">게시글번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={boardDetail.NOTI_NO}
											 readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">제목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={boardDetail.NOTI_TITLE}
											 readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">게시상태</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'}
											 value={boardDetail.NOTI_STS_CD == 'Y' ? '보임' : '숨김'} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">
									썸네일 <br/>
									(pixel: 340 × 270)
								</p>
								<div className="fo-value fs0">
									<img className="w125 h90" src={imgSrc} alt="" onClick={modaladm5322.open}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<UISunEditor value={boardDetail.NOTI_CONT} displayOnly={true} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<Suspense fallback={<PageLoading/>}>
											<UI.FileDownload value={notiFileValue} attrs={{ImgPreView: '1',}}/>
										</Suspense>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">조회수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={boardDetail.RET_CNT} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'} value={boardDetail.PERSON_NM} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 ">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w375'}
											 value={DateUtil.toDateFormat(boardDetail.REG_DATE, "YYYY-MM-DD")}
											 readOnly={true}/>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={onClickDelete}>삭제</Button>
						<Button color="pri-o" size="sm" onClick={onClickEdit}>수정</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>
				</main>
			</div>
			{/* modal - 5322 */}
			<ModalPopup
				open={modaladm5322.isShowing}
				title="미리보기"
				size="mid"
				onClose={modaladm5322.close}
			>
				<div className="modal-con">
					<img className="w100p" src={imgSrc} alt="" />
				</div>
				<div className="modal-bottom">
					<Button color='pri' size="big" onClick={modaladm5322.close}>확인</Button>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;